const STORAGE_KEY = "theofast-anonymous-visitor";

function createAnonymousId(cryptoApi) {
  if (typeof cryptoApi?.randomUUID === "function") return cryptoApi.randomUUID();
  if (typeof cryptoApi?.getRandomValues !== "function") return null;
  const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function getAnonymousVisitorId(storage, cryptoApi) {
  try {
    const browserStorage = storage || window.localStorage;
    const browserCrypto = cryptoApi || window.crypto;
    const existing = browserStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const created = createAnonymousId(browserCrypto);
    if (created) browserStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    return null;
  }
}
